import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import {
  CITY,
  COUNTRY,
  EMAIL,
  LINE1,
  LINE2,
  NAME,
  POSTAL_CODE,
  STATE
} from "APP_ROOT/constants";
import { CONTACT } from "MODULES/companies/constants";

export default function validate(values) {
  return validator(values, form => {
    form.validate(NAME).satisfies(rules.required);

    if (
      !values.website ||
      (values.contact && (values.contact.name || values.contact.email))
    ) {
      form.validateChild(CONTACT, contactForm => {
        contactForm.validate(NAME, EMAIL).satisfies(rules.required);
        contactForm.validate(EMAIL).satisfies(rules.isValidEmail);
      });
    }

    form.validateChild("billing_address", billingForm => {
      billingForm
        .validate(LINE1, CITY, STATE, POSTAL_CODE, COUNTRY)
        .satisfies(
          rules.requiredIfAnyDefined(
            LINE1,
            LINE2,
            CITY,
            STATE,
            POSTAL_CODE,
            COUNTRY
          )
        );
    });

    if (!values.same_as_billing) {
      form.validateChild("physical_address", physicalForm => {
        physicalForm
          .validate(LINE1, CITY, STATE, POSTAL_CODE, COUNTRY)
          .satisfies(
            rules.requiredIfAnyDefined(
              LINE1,
              LINE2,
              CITY,
              STATE,
              POSTAL_CODE,
              COUNTRY
            )
          );
      });
    }

    form.validateChild("shipping_method", (shippingForm, { carrier }) => {
      if (carrier) {
        shippingForm.validate("shipping_method").satisfies(rules.required);
      }
    });
  });
}



// WEBPACK FOOTER //
// ./app/modules/companies/components/CreateCompany/validate.js